import { useSelector, useDispatch } from 'react-redux'
import { Button, Tooltip } from '@mui/joy';
import { Save, Terminal, InstallDesktop } from '@mui/icons-material';
import { API_PATH, handleApiResponse } from '../Internal/api.js';
import React from 'react';


export default function SaveButton(){
    const dispatch = useDispatch();
    const intermediateState = useSelector(state => state.intermediateState);
    const decay = useSelector(state => state.decay);
    const finalStateData = useSelector(state => state.finalState);
    const currentBackend = useSelector(state => state.backend.currentBackend);
    const totalData = useSelector(state => state);

    const handleFileDownload = (str, name="myDecay.py") => {
        const element = document.createElement("a");
        const file = new Blob([str], {
          type: "text/plain"
        });
        element.href = URL.createObjectURL(file);
        element.download = name;
        document.body.appendChild(element);
        element.click();
      };
    const getCode = () => {
        // console.log(JSON.stringify({
        //     intermediateState: intermediateState,
        //     decay: decay,
        //     finalState: finalStateData,
        //     backend: currentBackend
        // }));
        const code = API_PATH + "amplitude";
        fetch(code, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                intermediateState: intermediateState,
                decay: decay,
                finalState: finalStateData,
                backend: currentBackend
            })
        })
        .then(response => handleApiResponse(response, dispatch))
        .then(data => {
            // console.log(data.code);
            handleFileDownload(data.code);
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }

    const getState = () => {
        // pop the pdgParticles entries
        const { pdgParticles, treeMask, checkedGraphs, decayLock, mainGraph, backend, lineshapeSchemas, ...rest } = totalData;
        handleFileDownload(JSON.stringify(rest), "state.json");
       
    }

    const getInstallScript = () => {
        const script = "python -m pip install decayamplitude --upgrade" + "\n" +
        "python -m pip install decayshape --upgrade"
        handleFileDownload(script, "install.sh");
    }

    return (
        <React.Fragment>
            <Tooltip title="Generate Amplitude Code" placement="top">
                <Button onClick={getCode}>
                    <Terminal/>
                </Button>
            </Tooltip>
            <Tooltip title="Download install helper" placement="top">
                <Button onClick={getInstallScript}>
                    <InstallDesktop/>
                </Button>
            </Tooltip>
            <Tooltip title="Save State to JSON" placement="top">
                <Button onClick={getState}>
                    <Save/>
                </Button>
            </Tooltip>
        </React.Fragment>
    )

}
